import { Chip } from "@heroui/react";
import { ReactElement, cloneElement } from "react";

interface InfoCardProps {
  header: string;
  total?: string | ReactElement<any>;
  title: string;
  icon: ReactElement<any>;
  iconWeight?: "thin" | "light" | "regular" | "bold" | "fill" | "duotone";
  iconSize?: number;
  label?: string;
}
export const InfoCard = ({
  header,
  total,
  title,
  icon,
  iconWeight = "duotone",
  iconSize = 18,
  label,
}: InfoCardProps) => {
  const iconWithProps = cloneElement(icon, {
    weight: iconWeight,
    size: iconSize,
  });
  return (
    <div className="group flex h-full flex-col gap-2 rounded-lg bg-white p-3.5 shadow-small duration-250 will-change-transform hover:scale-[1.0124]">
      <div className="flex items-center gap-1 text-neutral-primary">
        {iconWithProps}
        <p className="text-xs font-medium uppercase tracking-wider">{title}</p>
      </div>
      <p className="flex items-baseline gap-1 text-2xl font-semi-bold text-moss-primary">
        {header}
        {total && (
          <span className="text-sm font-medium text-neutral-secondary-mid">
            ({total} totaal)
          </span>
        )}
      </p>
      {label && (
        <Chip className="w-fit bg-moss-primary text-white">
          {label}
        </Chip>
      )}
    </div>
  );
};
